import React from 'react';

const KNModalSchemaErrors = (props) => {
    return(
        <>
            {
                Object.keys(props.schemaErrors).length ? (
                    <>
                        {Object.keys(props.schemaErrors).map((index, err) => 
                            <div key={'err-key-' + index} className={`mt-1 text-sm mb-2 text-red-400`}>
                                {props.schemaErrors[index]}
                            </div>
                        )}
                    </>
                ) : null
            }
        </>
    )
};

export default KNModalSchemaErrors;